import { ROUTES } from "@/constants/routes";
import { ChatService } from "@/services";
import { ChangeUserParams, CHAT_QUERY_KEYS } from "@/types";
import { toastApiError, toastSuccess } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

// Change owner of chat room
export const useChangeChatUser = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutateAsync, isPending } = useMutation({
    mutationKey: [CHAT_QUERY_KEYS.CHANGE_USER],
    mutationFn: async ({ id, data }: { id: number; data: ChangeUserParams }) =>
      ChatService.changeUser(id, data),
    retry: 1,
    onSuccess: (data) => {
      toastSuccess(data.message || "ユーザーが変更されました");

      // reset list room
      queryClient.invalidateQueries({ queryKey: [CHAT_QUERY_KEYS.ALL_CHATS] });

      // close current chat room, and open first chat room in list
      // get first page of list chage and route to first room
      ChatService.getChats({ page: 1, limit: 1 })
        .then((res) => {
          const firstRoom = res.data.pop();
          if (firstRoom) {
            navigate(`${ROUTES.CHAT}/${firstRoom.id}`);
          } else {
            sessionStorage.setItem("showEmptyDetailChat", "1");
            navigate(ROUTES.CHAT);
          }
        })
        .catch((err) => {
          toastApiError(err);
          navigate(ROUTES.CHAT);
        });
    },
    onError: toastApiError,
  });

  return {
    changeUser: mutateAsync,
    isChanging: isPending,
  };
};
